import { IonCol, IonContent, IonGrid, IonPage, IonRow } from "@ionic/react";
import { ReactNode } from "react";
import Me from "../Me/Me";
import TitlePage from "../TitlePage/TitlePage";

interface Props {
  pathReturn?: boolean;
  children?: ReactNode;
  title?: string;
  subtitle?: string;
  mainColStyle?: string;
  width?: string;
}

const BasicPage: React.FC<Props> = ({
  pathReturn,
  title,
  subtitle,
  children,
  mainColStyle,
  width = "5",
}) => {
  return (
    <IonPage>
      <IonContent color="primary">
        <IonGrid>
          <Me pathReturn={pathReturn ?? false}></Me>
          <IonRow className="ion-justify-content-center">
            <IonCol
              class="ion-justify-content-center"
              size-lg={width}
              size-sm="10"
              className={mainColStyle}
            >
              {(title || subtitle) && (
                <TitlePage
                  title={title ?? ""}
                  subTitle={subtitle ?? ""}
                ></TitlePage>
              )}
              {children}
            </IonCol>
          </IonRow>
        </IonGrid>
        {/* {window.location.pathname.includes("welcome") && <LYSCredit />} */}
      </IonContent>
    </IonPage>
  );
};

export default BasicPage;
